import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";

/**
 * SwUpdateBanner — aparece cuando el Service Worker detecta una nueva versión.
 * main.jsx despacha "sw-update-available" y guarda window.__swUpdate.
 */
export function SwUpdateBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handler = () => setVisible(true);
    window.addEventListener("sw-update-available", handler);
    return () => window.removeEventListener("sw-update-available", handler);
  }, []);

  if (!visible) return null;

  const handleUpdate = () => {
    if (typeof window.__swUpdate === "function") {
      window.__swUpdate(true);
    } else {
      window.location.reload();
    }
  };

  return (
    // v8.5.49 · piel · franja superior de 44px (antes píldora flotante abajo
    // con shadow-2xl) — banda de aviso, no un overlay: attention-soft/línea,
    // sin sombra, acciones como texto en vez de botón sólido.
    <div
      role="alert"
      className="fixed left-1/2 -translate-x-1/2 bottom-[88px] sm:bottom-5 z-[var(--z-notice)] flex items-center gap-4
                 px-4 py-2.5 rounded-[16px] shadow-[0_4px_16px_rgba(17,19,24,0.14)] max-w-[calc(100vw-24px)]
                 bg-[var(--accent-soft)] border border-[var(--accent-line)] text-[14px] text-[var(--accent-ink)]"
      style={{ animation: "swBannerIn 0.3s ease-out" }}
    >
      <span className="flex items-center gap-2 whitespace-nowrap">
        <RefreshCw className="h-4 w-4 shrink-0" />
        Nueva versión disponible
      </span>
      <button onClick={handleUpdate} className="font-medium hover:underline whitespace-nowrap">
        Actualizar
      </button>
      <button onClick={() => setVisible(false)} className="hover:underline whitespace-nowrap opacity-80">
        Ahora no
      </button>
    </div>
  );
}
